import { render } from "./FormComment.vue?vue&type=template&id=36c084d0&scoped=true"
import script from "./FormComment.vue?vue&type=script&lang=js"
export * from "./FormComment.vue?vue&type=script&lang=js"

import "./FormComment.vue?vue&type=style&index=0&id=36c084d0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36c084d0"]])

export default __exports__